<script>
  import Confirmation from '@/components/widgets/modals/Confirmation'
  import deviceConfig from './config/vss-adas-device-config.json'
  import * as vssConfiguration from '@/services/rest-api-sms/lib/vss-configuration/vss-configuration'
  import { numChannelMap } from '@/router/views/qcdevice/vssConfiguration/lib/vssconfiguration'

  export default {
    components: { Confirmation },
    props: {
      modal: { type: Boolean, default: false },
      isLoading: { type: Boolean, default: false },
      region: { type: String, default: 'SG' },
      adasInitialValue: { type: Object, default: null },
      deviceType: { type: String, default: '12004' },
      initialProfile: { type: Object, default: null },
    },
    data() {
      return {
        modalConfirm: false,
        modalUnsavedConfirm: false,
        linkageModal: false,
        activeRowIndex: null,
        originalFormData: null,
        filteredProfiles: [],
        oddDeviceType: [12004, 12006],
        linkageForm: {
          start_record: true,
          voice_broadcast: true,
          preview_mode: 'Model2',
          video_lock: [],
          video_upload: [],
          link_output: false,
          snapshot_upload: [],
          TimeOut1: '',
          preview: [],
        },
        previewModeOptions: [
          { id: 'Model1', name: 'Model1' },
          { id: 'Model2', name: 'Model2' },
        ],
        fields: [
          { key: 'type', label: 'Type' },
          { key: 'state', label: 'State' },
          { key: 'speed', label: 'Speed (km/h)' },
          { key: 'interval', label: 'Interval (s)' },
          { key: 'pre_record', label: 'Alarm pre-recording (s)' },
          { key: 'sensitivity', label: 'Sensitivity' },
          { key: 'alarm_linkage', label: 'Alarm Linkage' }
        ],
        stateOptions: [
          { id: 1, name: 'Enable' },
          { id: 0, name: 'Close' },
        ],
        sensitivityOptions: [
          { id: 0, name: 'High' },
          { id: 1, name: 'Middle' },
          { id: 2, name: 'Low' },
        ],
        channelOptions: Array.from({ length: 12 }, (_, i) => ({
          id: `CH${i + 1}`,
          name: `CH${i + 1}`,
        })),
        aiFrameOptions: [
          { id: 0, name: 'Close' },
          { id: 1, name: 'Enable' },
        ],
        installSelfCheckOptions: [
          { id: 1, name: 'Enable' },
          { id: 0, name: 'Disable' },
        ],
        defaultProfile: {
          id: 0,
          profile_name: 'Custom'
        },
        channelMap: {
          CH1: 1,
          CH2: 2,
          CH3: 4,
          CH4: 8,
          CH5: 16,
          CH6: 32,
          CH7: 64,
          CH8: 128,
          CH9: 256,
          CH10: 512,
          CH11: 1024,
          CH12: 2048,
        },
        form: {
          profile: {
            id: 0,
            profile_name: 'Custom'
          },
          profile_name: '', // for log purpose
          video_channel: 'CH2',
          draw_en: 0,
          installSelfCheck: 0,
          rows: [
            { key: 'fcw', type: 'Forward collision warning', state: 0, speed: 30, interval: 5, pre_record: 5, alarm_trigger: 0.5, sensitivity: 1, min_sensitivity: 1.6, max_sensitivity: 5.6 },
            { key: 'hmw', type: 'Headway monitoring warning', state: 0, speed: 30, interval: 5, pre_record: 5, alarm_trigger: 0.5, sensitivity: 1, min_sensitivity: 0.6, max_sensitivity: 2.6 },
            { key: 'ldw', type: 'Lane departure warning', state: 0, speed: 30, interval: 5, pre_record: 5, alarm_trigger: 0.5, sensitivity: 1, min_sensitivity: -1, max_sensitivity: 1 },
            { key: 'pcw', type: 'Pedestrian collision warning', state: 0, speed: 30, interval: 5, pre_record: 5, alarm_trigger: 0.5, sensitivity: 1, min_sensitivity: 0.5, max_sensitivity: 4.5 },
          ],
          calibration: {
            camera_height_cm: 0,
            camera_to_bumper_cm: 0,
            camera_to_centerline_cm: 0,
            camera_to_axle_cm: 0,
            vehicle_width_cm: 0,
            bottomExtraWidth: 0,
            brakeTime: 0,
            iCameraToLeftWheel: 0
          },
          other: {
            horizon_pixel: 334,
            centerline_pixel: 634,
          },

        },
      }
    },
    computed: {
      showModal: {
        get() { return this.modal }
      },
      loading: {
        get() { return this.isLoading },
        set(v) { this.$emit('update:isLoading', v) },
      },
      currentDeviceConfig() {
        return deviceConfig[this.deviceType] || {}
      },
    },
    methods: {
      hasUnsavedChanges() {
        if (!this.originalFormData) return false
        return JSON.stringify(this.form) !== JSON.stringify(this.originalFormData)
      },
      saveOriginalFormData() {
        this.originalFormData = JSON.parse(JSON.stringify(this.form))
      },
      closeModalWithoutSaving() {
        this.modalUnsavedConfirm = false
        this.resetToDefaultValue()
        this.$emit('update:modal', false)
      },
      saveAndCloseModal() {
        this.modalUnsavedConfirm = false
        this.openConfirm()
      },
      closeModal() {
        if (this.hasUnsavedChanges()) {
          this.modalUnsavedConfirm = true
        } else {
          this.$emit('update:modal', false)
        }
      },
      resetToDefaultValue() {
        this.form = this.originalFormData
      },
      async getProfiles() {
        const params = {
          filters: ["type eq 'adas'", `device_code eq ${this.deviceType}`],
          limit: 99999999999,
          page: 1,
          sorts: ['created_at desc']
        }

        const response = await vssConfiguration.get(params)
        this.filteredProfiles = [this.defaultProfile, ...response?.data?.paginated_result]

        const currentProfile = this.filteredProfiles.find(
          (profile) => 
            profile.id === Number(this.initialProfile?.status_text ?? 0) 
        )
        this.form.profile = currentProfile ?? this.defaultProfile
        this.form.profile_name = currentProfile?.profile_name ?? 'Custom'
      },
      selectProfile(profileId) {
        const selectedProfile = this.filteredProfiles.find(
          p => p.id === profileId
        ) || null

        this.form.profile_name = selectedProfile.profile_name ?? 'Custom'
 
        const defaultData = selectedProfile
        if (!defaultData) return


        // Reset video channel
        if (defaultData.chn) {
          this.form.video_channel = numChannelMap[defaultData.chn] || 'CH2'
        }

        // Reset AI frame
        this.form.draw_en = Number(defaultData.draw_en ?? 0)
        this.form.installSelfCheck = Number(defaultData.install_self_check ?? 0)

        // Reset calibration values
        if (defaultData.cam_height !== null && defaultData.cam_height !== undefined) {
          this.form.calibration.camera_height_cm = defaultData.cam_height
        }
        if (defaultData.cam_to_bumper !== null && defaultData.cam_to_bumper !== undefined) {
          this.form.calibration.camera_to_bumper_cm = defaultData.cam_to_bumper
        }
        if (defaultData.cam_to_center !== null && defaultData.cam_to_center !== undefined) {
          this.form.calibration.camera_to_centerline_cm = defaultData.cam_to_center
        }
        if (defaultData.cam_to_axle !== null && defaultData.cam_to_axle !== undefined) {
          this.form.calibration.camera_to_axle_cm = defaultData.cam_to_axle
        }
        if (defaultData.vehicle_width !== null && defaultData.vehicle_width !== undefined) {
          this.form.calibration.vehicle_width_cm = defaultData.vehicle_width
        }
        if (defaultData.bottom_extra_width !== null && defaultData.bottom_extra_width !== undefined) {
          this.form.calibration.bottomExtraWidth = defaultData.bottom_extra_width
        }
        if (defaultData.brake_time !== null && defaultData.brake_time !== undefined) {
          this.form.calibration.brakeTime = defaultData.brake_time
        }
        if (defaultData.extraHeight !== null && defaultData.extraHeight !== undefined) {
          this.form.calibration.extraHeight = defaultData.extraHeight
        }
        if (defaultData.lineRoi !== null && defaultData.lineRoi !== undefined) {
          this.form.calibration.lineRoi = defaultData.lineRoi
        }
        if (defaultData.i_camera_to_left_wheel !== null && defaultData.i_camera_to_left_wheel !== undefined) {
          this.form.calibration.iCameraToLeftWheel = defaultData.i_camera_to_left_wheel
        }

        // Reset other values
        if (defaultData.horizon_line !== null && defaultData.horizon_line !== undefined) {
          this.form.other.horizon_pixel = defaultData.horizon_line
        }
        if (defaultData.centerline !== null && defaultData.centerline !== undefined) {
          this.form.other.centerline_pixel = defaultData.centerline
        }

        // Reset alarm settings from default values
        if (defaultData.alarm_settings && Array.isArray(defaultData.alarm_settings)) {
          this.form.rows = this.form.rows.map((row) => {
            const matchingAlarm = defaultData.alarm_settings.find(alarm => 
              alarm.type === row.key
            )
            
            if (matchingAlarm) {
              let sensitivity = matchingAlarm.sensitivity !== null && matchingAlarm.sensitivity !== undefined ? matchingAlarm.sensitivity : row.sensitivity
              return {
                ...row,
                state: matchingAlarm.state ?? 0,
                speed: matchingAlarm.speed ?? row.speed,
                interval: matchingAlarm.interval ?? row.interval,
                pre_record: matchingAlarm.alm_triger_pre_recording ?? row.pre_record,
                alarm_trigger: matchingAlarm.alm_triger_hold_time ?? row.alarm_trigger ?? 0.5,
                sensitivity: sensitivity,
                linkage: {
                  start_record: matchingAlarm.record,
                  voice_broadcast: matchingAlarm.link_buzzer,
                  preview_mode: matchingAlarm.link_preview_mode === 1 ? 'Model2' : 'Model1',
                  video_lock: this.maskToChannels(matchingAlarm.link_lock_chn ?? 0),
                  video_upload: this.maskToChannels(matchingAlarm.link_video_upload_chn ?? 0),
                  link_output: matchingAlarm.link_output === 1,
                  snapshot_upload: this.maskToChannels(matchingAlarm.link_snap_chn ?? 0),
                  TimeOut1: String(matchingAlarm.out1_time ?? 10),
                  preview: this.maskToChannels(matchingAlarm.link_preview_chn ?? 0),
                }
              }
            }
            return row
          })
        }
      },
      openConfirm() { 
        // Validate for deviceType 12004
        if (this.oddDeviceType.includes(Number(this.deviceType))) {
          const bt = this.form.calibration.brakeTime
          const bew = this.form.calibration.bottomExtraWidth
          const cl = this.form.other.centerline_pixel
          
          if (bt < 0 || bt > 2.5) {
            this.$toast.error('Brake Time must be between 0 and 2.5')
            return
          }
          if (bew < 0 || bew > 5) {
            this.$toast.error('Bottom Extra Width must be between 0 and 5')
            return
          }
          if (cl < -60 || cl > 60) {
            this.$toast.error('Centerline must be between -60 and 60')
            return
          }
        }
        this.modalConfirm = true 
      },
      afterConfirm() {
        const chn = (this.form.video_channel || 'CH2').replace(/[^0-9]/g, '') || '2'
        const toStr = (v) => (v === undefined || v === null ? '' : String(v))
        const boolTo01 = (v) => (v ? '1' : '0')
        const rowByKey = (key) => this.form.rows.find((r) => r.key === key) || {}
        const channelsToMask = (arr = []) => {
          return String((arr || []).reduce((m, ch) => m | (this.channelMap[ch] || 0), 0))
        }
        const previewModeToCode = (mode) => (mode === 'Model2' ? '1' : '0')
        const normalizeAlarmTrigger = (sensitivity, alarmTrigger) => {
          if (this.oddDeviceType.includes(Number(this.deviceType))) {
            return sensitivity
          }
          else return alarmTrigger
        }
        const buildAlarm = (row = {}) => {
          const lg = row?.linkage || {}
          return {
            enable: String(row.state) === '1' ? '1' : '0',
            limit: toStr(row.speed ?? row.limit ?? ''),
            delay: toStr(row.interval ?? ''),
            holdtime: toStr(row.pre_record ?? ''),
            AlmTrigerHoldTime: normalizeAlarmTrigger(row.sensitivity, toStr(row.alarm_trigger ?? '0.5')),
            record: boolTo01(lg.start_record ?? true),
            linkBuzzer: boolTo01(lg.voice_broadcast ?? true),
            linkPreviewMode: previewModeToCode(lg.preview_mode ?? 'Model2'),
            linkLockChn: channelsToMask(lg.video_lock || []),
            linkUploadChn: channelsToMask(lg.video_upload || []),
            linkOutput: boolTo01(!!lg.link_output),
            linkSnapChn: channelsToMask(lg.snapshot_upload || []),
            PreviewChn: channelsToMask(lg.preview || []),
            TimeOut1: Number(lg.TimeOut1)
          }
        }

        const ADAS = {
          profile_id: this.form.profile.id ?? this.form.profile,
          chn: toStr(chn),
          drawEn: toStr(this.form.draw_en ?? 0),
          installSelfCheck: toStr(this.form.installSelfCheck ?? 0),
          camera_height: toStr(this.form.calibration?.camera_height_cm),
          cam_dist_head: toStr(this.form.calibration?.camera_to_bumper_cm),
          cam_dist_axle: toStr(this.form.calibration?.camera_to_axle_cm),
          vehicle_width: toStr(this.form.calibration?.vehicle_width_cm),
          horizon_line: toStr(this.form.other?.horizon_pixel),
          vehicle_Mid_line: toStr(this.form.other?.centerline_pixel),
          bottomExtraWidth: toStr(this.form.calibration?.bottomExtraWidth),
          brakeTime: toStr(this.form.calibration?.brakeTime),
          iCameraToLeftWheel: toStr(this.form.calibration?.iCameraToLeftWheel),

          fcw_alarm: buildAlarm(rowByKey('fcw')),
          fcw_sensitivity: toStr(rowByKey('fcw').sensitivity ?? '1.000000'),
          iCameraCenter: toStr(this.form.calibration?.camera_to_centerline_cm),
          hmw_alarm: buildAlarm(rowByKey('hmw')),
          hmw_sensitivity: toStr(rowByKey('hmw').sensitivity ?? '1.000000'),
          ldw_alarm: buildAlarm(rowByKey('ldw')),
          ldw_sensitivity: toStr(rowByKey('ldw').sensitivity ?? '1.000000'),
          pcw_alarm: buildAlarm(rowByKey('pcw')),
          pcw_sensitivity: toStr(rowByKey('pcw').sensitivity ?? '1.000000'),
        }

        const changedFields = this.getChangedFields()
        
        this.$emit('beforeSubmit', { type: 'ADAS', ADAS, changes: changedFields })
        this.$emit('update:modal', false)
      },
      async initFromInitial() {
        await this.getProfiles()
        this.saveOriginalFormData()
        
        const A = this.adasInitialValue
        if (!A) return
        if (A.chn) this.form.video_channel = `CH${String(A.chn).replace(/[^0-9]/g, '')}`

        // AI frame
        this.form.draw_en = Number(A.drawEn)
        this.form.installSelfCheck = Number(A.installSelfCheck ?? A.install_self_check ?? 0)

        // calibration / other
        if (A.camera_height) this.form.calibration.camera_height_cm = Number(A.camera_height)
        if (A.cam_dist_head) this.form.calibration.camera_to_bumper_cm = Number(A.cam_dist_head)
        if (A.cam_dist_axle) this.form.calibration.camera_to_axle_cm = Number(A.cam_dist_axle)
        if (A.vehicle_width) this.form.calibration.vehicle_width_cm = Number(A.vehicle_width)
        if (A.iCameraCenter) this.form.calibration.camera_to_centerline_cm = Number(A.iCameraCenter)
        if (A.bottomExtraWidth) this.form.calibration.bottomExtraWidth = Number(A.bottomExtraWidth)
        if (A.brakeTime) this.form.calibration.brakeTime = Number(A.brakeTime)
        if (A.iCameraToLeftWheel) this.form.calibration.iCameraToLeftWheel = Number(A.iCameraToLeftWheel)
        if (A.horizon_line) this.form.other.horizon_pixel = Number(A.horizon_line)
        if (A.vehicle_Mid_line) this.form.other.centerline_pixel = Number(A.vehicle_Mid_line)
        if (A.extraHeight) this.form.calibration.extraHeight = A.extraHeight
        if (A.lineRoi) this.form.calibration.lineRoi = A.lineRoi

        // alarms
        const map = {
          fcw: { alarm: A.fcw_alarm, sens: A.fcw_sensitivity },
          hmw: { alarm: A.hmw_alarm, sens: A.hmw_sensitivity },
          ldw: { alarm: A.ldw_alarm, sens: A.ldw_sensitivity },
          pcw: { alarm: A.pcw_alarm, sens: A.pcw_sensitivity },
        }
        const normalizeSensitivity = (v, alarmTrigger) => {
          if (this.oddDeviceType.includes(Number(this.deviceType))) {
            return Number(alarmTrigger)
          }
          else return parseInt(v ?? '1.000000')
        }
        const parseLinkage = (src) => {
          if (!src) return null
          
          const previewModeCode = String(src.linkPreviewMode ?? '1')
          const previewMode = previewModeCode === '1' ? 'Model2' : 'Model1'
          
          return {
            start_record: Number(src.record ?? 0),
            voice_broadcast: Number(src.linkBuzzer ?? 0),
            preview_mode: previewMode,
            video_lock: this.maskToChannels(Number(src.linkLockChn ?? 0)),
            video_upload: this.maskToChannels(Number(src.linkUploadChn ?? 0)),
            link_output: Number(src.linkOutput ?? 0) === 1,
            snapshot_upload: this.maskToChannels(Number(src.linkSnapChn ?? 0)),
            TimeOut1: String(src.TimeOut1 ?? ''),
            preview: this.maskToChannels(Number(src.PreviewChn ?? 0)),
          }
        }
        this.form.rows = this.form.rows.map((r) => {
          const src = map[r.key]?.alarm
          const sens = map[r.key]?.sens
          if (!src) return r

          return {
            ...r,
            state: Number(src.enable) ?? 0,
            speed: Number(src.limit ?? r.speed ?? 0),
            interval: Number(src.delay ?? r.interval ?? 0),
            pre_record: Number(src.holdtime ?? r.pre_record ?? 0),
            sensitivity: normalizeSensitivity(sens ?? r.sensitivity, src.AlmTrigerHoldTime ?? r.alarm_trigger),
            alarm_trigger: normalizeSensitivity(sens ?? r.sensitivity, src.AlmTrigerHoldTime ?? r.alarm_trigger),
            linkage: parseLinkage(src),
          }
        })
        this.saveOriginalFormData()
      },
      openLinkage(item, index) {
        this.activeRowIndex = index
        const saved = item.linkage || {}
        this.linkageForm = {
          start_record: saved.start_record ?? true,
          voice_broadcast: saved.voice_broadcast ?? true,
          preview_mode: saved.preview_mode ?? 'Model2',
          video_lock: Array.isArray(saved.video_lock) ? [...saved.video_lock] : [],
          video_upload: Array.isArray(saved.video_upload) ? [...saved.video_upload] : [],
          link_output: saved.link_output ?? false,
          snapshot_upload: Array.isArray(saved.snapshot_upload) ? [...saved.snapshot_upload] : [],
          TimeOut1: saved.TimeOut1 ?? '',
          preview: Array.isArray(saved.preview) ? [...saved.preview] : [],
        }
        this.linkageModal = true
      },
      saveLinkage() {
        if (this.activeRowIndex !== null) {
          const row = this.form.rows[this.activeRowIndex]
          row.linkage = JSON.parse(JSON.stringify(this.linkageForm))
        }
        this.linkageModal = false
      },
      doCalibrate() {
        const payload = JSON.parse(JSON.stringify(this.form.calibration))
        this.$emit('calibrate', { payload })
      },
      maskToChannels(mask) {
        const channels = []
        Object.entries(this.channelMap).forEach(([ch, value]) => {
          if (mask & value) {
            channels.push(ch)
          }
        })
        return channels
      },
      onlyNumber(evt) {
        const c = String.fromCharCode(evt.which)
        if (!/[0-9]/.test(c)) evt.preventDefault()
      },
      isFieldEnabled(rowKey, fieldName) {
        const config = this.currentDeviceConfig[rowKey]
        if (!config) return true
        return config[fieldName] !== false
      },
      chageCustomProfile() {
        this.form.profile = this.defaultProfile
        this.form.profile_name = 'Custom'
      },
      validateRange(value, min, max) {
        if (value === null || value === undefined || value === '') return null
        return value >= min && value <= max
      },
      getChangedFields() {
        if (!this.originalFormData) return null

        const changes = []
        
        const formatValue = (value, fieldName) => {
          if (fieldName === 'state') {
            const option = this.stateOptions.find(o => o.id === value)
            return option ? option.name : value
          }
          if (fieldName === 'sensitivity') {
            const option = this.sensitivityOptions.find(o => o.id === value)
            return option ? option.name : value
          }
          if (fieldName === 'preview_mode') {
            const option = this.previewModeOptions.find(o => o.id === value)
            return option ? option.name : value
          }
          if (fieldName === 'video_channel') {
            return value
          }
          if (fieldName === 'start_record') {
            const option = this.stateOptions.find(o => o.id === value)
            return option ? option.name : value
          }
          if (fieldName === 'voice_broadcast') {
            const option = this.stateOptions.find(o => o.id === value)
            return option ? option.name : value
          }
          if (fieldName === 'draw_en') {
            const option = this.aiFrameOptions.find(o => o.id === value)
            return option ? option.name : value
          }
          if (fieldName === 'installSelfCheck') {
            const option = this.installSelfCheckOptions.find(o => o.id === value)
            return option ? option.name : value
          }
          if (Array.isArray(value)) {
            return value.sort().join(',')
          }
          return value
        }
        
        const compareObjects = (original, current, path = '') => {
          const excludedKey = ['profile', 'profile.id']
          for (const key in current) {
            const currentPath = path ? `${path}.${key}` : key
            
            if (excludedKey.includes(currentPath)) continue
            
            if (typeof current[key] === 'object' && current[key] !== null && !Array.isArray(current[key])) {
              if (original[key]) {
                compareObjects(original[key], current[key], currentPath)
              }
            } else if (Array.isArray(current[key])) {
              if (JSON.stringify(original[key]) !== JSON.stringify(current[key])) {
                const maxLength = Math.max(original[key]?.length || 0, current[key].length)
                for (let i = 0; i < maxLength; i++) {
                  const origItem = original[key]?.[i]
                  const currItem = current[key][i]
                  
                  if (typeof currItem === 'object' && currItem !== null) {
                    for (const prop in currItem) {
                      if (prop === 'type' || prop === 'key') continue
                      
                      // Handle nested objects like linkage
                      if (typeof currItem[prop] === 'object' && currItem[prop] !== null && !Array.isArray(currItem[prop])) {
                        const origNested = origItem?.[prop]
                        const currNested = currItem[prop]
                        
                        if (JSON.stringify(origNested) !== JSON.stringify(currNested)) {
                          // Compare each nested property
                          for (const nestedKey in currNested) {
                            if (JSON.stringify(origNested?.[nestedKey]) !== JSON.stringify(currNested[nestedKey])) {
                              const fieldPath = `${currItem.key}.${prop}.${nestedKey}`
                              changes.push({
                                field: fieldPath,
                                before: formatValue(origNested?.[nestedKey], nestedKey).toString(),
                                after: formatValue(currNested[nestedKey], nestedKey).toString()
                              })
                            }
                          }
                        }
                      } else if (JSON.stringify(origItem?.[prop]) !== JSON.stringify(currItem[prop])) {
                        const fieldPath = `${currItem.key}.${prop}`
                        changes.push({
                          field: fieldPath,
                          before: formatValue(origItem?.[prop], prop).toString(),
                          after: formatValue(currItem[prop], prop).toString()
                        })
                      }
                    }
                  }
                }
              }
            } else if (JSON.stringify(original[key]) !== JSON.stringify(current[key])) {
              // Value has changed
              changes.push({
                field: currentPath,
                before: formatValue(original[key], key),
                after: formatValue(current[key], key)
              })
            }
          }
        }

        compareObjects(this.originalFormData, this.form)
        return changes
      }
    },
    watch: {
      modal(newVal) {
        if (newVal) {
          this.initFromInitial()
        } 
      },
      adasInitialValue: {
        handler() {
          if (this.modal) {
            this.initFromInitial()
          } 
        },
        deep: true,
      },
    },
  }
</script>

<template>
  <div>
    <b-modal
      v-model="showModal"
      class="mc-modal"
      id="modal-form-adas-vss"
      title="ADAS setting"
      size="xl"
      centered
      :hide-header-close="true"
      no-close-on-backdrop
      hide-footer
    >
      <div class="card-body mc-modal__filter p-2">
        <b-form @submit.stop.prevent>
          <b-row class="mb-2">
            <b-col cols="12" md="4" class="mb-2">
              <label class="mt-1">ADAS Profile</label>
              <v-select
                v-model="form.profile"
                :options="filteredProfiles"
                label="profile_name"
                :reduce="v => v.id"
                :clearable="false"
                placeholder="Select channel"
                @input="selectProfile"
              />
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col cols="12" md="4" class="mb-2">
              <label class="mt-1">Video channel</label>
              <v-select
                v-model="form.video_channel"
                :options="channelOptions"
                label="name"
                :reduce="v => v.id"
                :clearable="false"
                placeholder="Select channel"
                @input="chageCustomProfile"
              />
            </b-col>
            <b-col cols="12" md="4" class="mb-2">
              <label class="mt-1">AI frame</label>
              <v-select
                v-model="form.draw_en"
                :options="aiFrameOptions"
                label="name"
                :reduce="v => v.id"
                :clearable="false"
                placeholder="Select AI frame"
                @input="chageCustomProfile"
              />
            </b-col>
            <b-col cols="12" md="4" class="mb-2">
              <label class="mt-1">Install self check</label>
              <v-select
                v-model="form.installSelfCheck"
                :options="installSelfCheckOptions"
                label="name"
                :reduce="v => v.id"
                :clearable="false"
                placeholder="Select install self check"
                @input="chageCustomProfile"
              />
            </b-col>
          </b-row>

          <div class="table-responsive my-2 border border-1">
            <b-table
              small
              show-empty
              :items="form.rows"
              :fields="fields"
              head-variant="light"
            >
              <template #cell(type)="{ item }">
                <strong>{{ item.type }}</strong>
              </template>
              <template #cell(state)="{ item }">
                <v-select
                  v-model="item.state"
                  :options="stateOptions"
                  label="name"
                  :reduce="v => v.id"
                  :clearable="false"
                  placeholder="State"
                  @input="chageCustomProfile"
                  :disabled="!isFieldEnabled(item.key, 'state')"
                />
              </template>
              <template #cell(speed)="{ item }">
                <b-form-input
                  v-model.number="item.speed"
                  type="number"
                  min="0"
                  @keypress="onlyNumber"
                  @input="chageCustomProfile"
                  :disabled="!isFieldEnabled(item.key, 'speed')"
                />
              </template>
              <template #cell(interval)="{ item }">
                <b-form-input
                  v-model.number="item.interval"
                  type="number"
                  min="0"
                  @keypress="onlyNumber"
                  @input="chageCustomProfile"
                  :disabled="!isFieldEnabled(item.key, 'interval')"
                />
              </template>
              <template #cell(pre_record)="{ item }">
                <b-form-input
                  v-model.number="item.pre_record"
                  type="number"
                  min="0"
                  @keypress="onlyNumber"
                  @input="chageCustomProfile"
                  :disabled="!isFieldEnabled(item.key, 'pre_record')"
                />
              </template>
              <template #cell(alarm_linkage)="{ item, index }">
                <b-button 
                  :variant="isFieldEnabled(item.key, 'alarm_linkage') ? 'outline-primary' : 'secondary'" 
                  size="sm" 
                  @click="openLinkage(item, index)" :disabled="!isFieldEnabled(item.key, 'alarm_linkage')">
                  Alarm linkage
                </b-button>
              </template>
              <template #cell(sensitivity)="{ item }">
                <v-select
                  v-if="!oddDeviceType.includes(Number(deviceType))"
                  v-model="item.sensitivity"
                  :options="sensitivityOptions"
                  label="name"
                  :reduce="v => v.id"
                  placeholder="State"
                  :clearable="false"
                  @input="chageCustomProfile"
                  :disabled="!isFieldEnabled(item.key, 'sensitivity')"
                />
                <b-form-input
                  v-else
                  v-model="item.sensitivity"
                  type="text"
                  inputmode="decimal"
                  :min="item.min_sensitivity"
                  :max="item.max_sensitivity"
                  @input="chageCustomProfile"
                  :disabled="!isFieldEnabled(item.key, 'sensitivity')"
                />
              </template>
            </b-table>
          </div>

          <hr class="my-3" />
          <h6 class="mb-3">ADAS Calibration</h6>
          <b-row>
            <b-col cols="12" md="6" class="mb-2">
              <label>Camera Height (cm)</label>
              <b-form-input v-model.number="form.calibration.camera_height_cm" type="number" min="0" @keypress="onlyNumber" @input="chageCustomProfile" :disabled="!isFieldEnabled('calibration', 'camera_height_cm')" />
            </b-col>
            <b-col cols="12" md="6" class="mb-2">
              <label>Camera to Bumper (cm)</label>
              <b-form-input v-model.number="form.calibration.camera_to_bumper_cm" type="number" min="0" @keypress="onlyNumber" @input="chageCustomProfile" :disabled="!isFieldEnabled('calibration', 'camera_to_bumper_cm')" />
            </b-col>
            <b-col cols="12" md="6" class="mb-2">
              <label>Camera to Centerline (cm)</label>
              <b-form-input v-model.number="form.calibration.camera_to_centerline_cm" type="number" min="0" @keypress="onlyNumber" @input="chageCustomProfile" :disabled="!isFieldEnabled('calibration', 'camera_to_centerline_cm')" />
            </b-col>
            <b-col cols="12" md="6" class="mb-2">
              <label>Camera to Axle (cm)</label>
              <b-form-input v-model.number="form.calibration.camera_to_axle_cm" type="number" min="0" @keypress="onlyNumber" @input="chageCustomProfile" :disabled="!isFieldEnabled('calibration', 'camera_to_axle_cm')" />
            </b-col>
            <b-col cols="12" md="6" class="mb-2">
              <label>Vehicle Width (cm)</label>
              <b-form-input v-model.number="form.calibration.vehicle_width_cm" type="number" min="0" @keypress="onlyNumber" @input="chageCustomProfile" :disabled="!isFieldEnabled('calibration', 'vehicle_width_cm')" />
            </b-col>
            <b-col cols="12" md="6" class="mb-2">
              <label>Bottom Extra Width</label>
              <b-form-input   
                v-model.number="form.calibration.bottomExtraWidth" 
                type="number" 
                step="0.001" 
                min="0" 
                :max="oddDeviceType.includes(Number(deviceType)) ? 5 : undefined"
                @input="chageCustomProfile" 
                :disabled="!isFieldEnabled('calibration', 'bottomExtraWidth')"
                :state="oddDeviceType.includes(Number(deviceType)) ? validateRange(form.calibration.bottomExtraWidth, 0, 5) : null"
              />
              <b-form-invalid-feedback v-if="oddDeviceType.includes(Number(deviceType))" :state="validateRange(form.calibration.bottomExtraWidth, 0, 5)">
                Bottom Extra Width must be between 0 and 5
              </b-form-invalid-feedback>
            </b-col>
            <b-col cols="12" md="6" class="mb-2">
              <label>Brake Time</label>
              <b-form-input 
                v-model.number="form.calibration.brakeTime" 
                type="number" 
                step="0.001" 
                min="0" 
                :max="oddDeviceType.includes(Number(deviceType)) ? 2.5 : undefined"
                @input="chageCustomProfile" 
                :disabled="!isFieldEnabled('calibration', 'brakeTime')"
                :state="oddDeviceType.includes(Number(deviceType)) ? validateRange(form.calibration.brakeTime, 0, 2.5) : null"
              />
              <b-form-invalid-feedback v-if="oddDeviceType.includes(Number(deviceType))" :state="validateRange(form.calibration.brakeTime, 0, 2.5)">
                Brake Time must be between 0 and 2.5
              </b-form-invalid-feedback>
            </b-col>
            <b-col cols="12" md="6" class="mb-2">
              <label>The horizontal distance between the camera and the left front wheel</label>
              <b-form-input v-model.number="form.calibration.iCameraToLeftWheel" :disabled="!isFieldEnabled('calibration', 'iCameraToLeftWheel')" type="number" min="0" @keypress="onlyNumber" @input="chageCustomProfile" />
            </b-col>
            <b-col cols="12" md="6" class="mb-2">
              <label>Extra height (M)</label>
              <b-form-input v-model.number="form.calibration.extraHeight" :disabled="!isFieldEnabled('calibration', 'extraHeight')" type="number" min="0" @keypress="onlyNumber" @input="chageCustomProfile" />
            </b-col>
            <b-col cols="12" md="6" class="mb-2">
              <label>Dynamic lane width</label>
              <b-form-input v-model.number="form.calibration.lineRoi" :disabled="!isFieldEnabled('calibration', 'lineRoi')" type="number" min="0" @keypress="onlyNumber" @input="chageCustomProfile" />
            </b-col>
          </b-row>

          <hr class="my-3" />
          <h6 class="mb-3">Other</h6>
          <b-row>
            <b-col cols="12" md="6" class="mb-2">
              <label>Horizon (pixel)</label>
              <b-form-input v-model.number="form.other.horizon_pixel" type="number" min="0" @keypress="onlyNumber" @input="chageCustomProfile" :disabled="!isFieldEnabled('other', 'horizon_pixel')" />
            </b-col>
            <b-col cols="12" md="6" class="mb-2">
              <label>Centerline (pixel)</label>
              <b-form-input 
                v-model.number="form.other.centerline_pixel" 
                type="number" 
                :min="oddDeviceType.includes(Number(deviceType)) ? -60 : 0"
                :max="oddDeviceType.includes(Number(deviceType)) ? 60 : undefined"
                @keypress="!oddDeviceType.includes(Number(deviceType)) ? onlyNumber : null"
                @input="chageCustomProfile" 
                :disabled="!isFieldEnabled('other', 'centerline_pixel')"
                :state="oddDeviceType.includes(Number(deviceType)) ? validateRange(form.other.centerline_pixel, -60, 60) : null"
              />
              <b-form-invalid-feedback v-if="oddDeviceType.includes(Number(deviceType))" :state="validateRange(form.other.centerline_pixel, -60, 60)">
                Centerline must be between -60 and 60
              </b-form-invalid-feedback>
            </b-col>
          </b-row>
          <div class="d-flex gap-2">
            <b-button variant="secondary" @click="doCalibrate" @input="chageCustomProfile">Calibrate</b-button>
          </div>

          <hr class="my-3" />
        </b-form>
      </div>


      <template>
        <div class="mx-2 d-flex justify-content-between align-items-center mx-2">
          <p v-if="!this.adasInitialValue" class="text-danger">Device offline cannot be saved</p>
          <div :class="{ 'ms-auto': this.adasInitialValue }">
            <b-button variant="outline-primary" @click="closeModal" :disabled="loading" class="me-3">
              Batal
            </b-button>
            <b-button @click="openConfirm" variant="primary" :disabled="loading || !this.adasInitialValue" >
              <b-spinner v-if="loading" small type="grow"></b-spinner>
              {{ loading ? 'Loading...' : 'Simpan' }}
            </b-button>
          </div>
        </div>
      </template>
    </b-modal>

    <b-modal
      v-model="linkageModal"
      class="mc-modal"
      id="modal-alarm-linkage-adas-vss"
      title="Alarm linkage"
      size="xl"
      centered
      hide-footer
    >
      <div class="card-body p-2">
        <b-row>
          <b-col cols="12" md="6">
            <b-row class="mb-2 align-items-center">
              <b-col cols="5">Start record</b-col>
              <b-col cols="7">
                <v-select
                  v-model="linkageForm.start_record"
                  :options="stateOptions"
                  label="name"
                  :reduce="v => v.id"
                  :clearable="false"
                  @input="chageCustomProfile"
                />
              </b-col>
            </b-row>
            <b-row class="mb-2 align-items-center">
              <b-col cols="5">Preview mode</b-col>
              <b-col cols="7">
                <v-select
                  v-model="linkageForm.preview_mode"
                  :options="previewModeOptions"
                  label="name"
                  :reduce="v => v.id"
                  :clearable="false"
                  @input="chageCustomProfile"
                />
              </b-col>
            </b-row>
            <b-row class="mb-2 align-items-center">
              <b-col cols="5">Video Upload</b-col>
              <b-col cols="7">
                <div class="d-flex flex-wrap">
                  <b-form-checkbox v-for="ch in channelOptions" :key="'up-'+ch.id" v-model="linkageForm.video_upload" :value="ch.id" class="me-2" @input="chageCustomProfile">
                    <label class="ms-1">{{ ch.name }}</label>
                  </b-form-checkbox>
                </div>
              </b-col>
            </b-row>
            <b-row class="mb-2 align-items-center">
              <b-col cols="5">Out1 output time</b-col>
              <b-col cols="7">
                <b-form-input v-model="linkageForm.TimeOut1" @input="chageCustomProfile" />
              </b-col>
            </b-row>
            <b-row class="mb-2 align-items-center">
              <b-col cols="5">Preview</b-col>
              <b-col cols="7">
                <div class="d-flex flex-wrap">
                  <b-form-checkbox v-for="ch in channelOptions" :key="'prev-'+ch.id" v-model="linkageForm.preview" :value="ch.id" class="me-2" @input="chageCustomProfile">
                    <label class="ms-1">{{ ch.name }}</label>
                  </b-form-checkbox>
                </div>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12" md="6">
            <b-row class="mb-2 align-items-center">
              <b-col cols="5">Voice broadcast</b-col>
              <b-col cols="7">
                <v-select
                  v-model="linkageForm.voice_broadcast"
                  :options="stateOptions"
                  label="name"
                  :reduce="v => v.id"
                  :clearable="false"
                  @input="chageCustomProfile"
                />
              </b-col>
            </b-row>
            <b-row class="mb-2 align-items-center">
              <b-col cols="5">Video lock</b-col>
              <b-col cols="7">
                <div class="d-flex flex-wrap">
                  <b-form-checkbox v-for="ch in channelOptions" :key="'lock-'+ch.id" v-model="linkageForm.video_lock" :value="ch.id" class="me-2" @input="chageCustomProfile">
                    <label class="ms-1">{{ ch.name }}</label>
                  </b-form-checkbox>
                </div>
              </b-col>
            </b-row>
            <b-row class="mb-2 align-items-center">
              <b-col cols="5">Link output</b-col>
              <b-col cols="7">
                <b-form-checkbox v-model="linkageForm.link_output" @input="chageCustomProfile">OUT1</b-form-checkbox>
              </b-col>
            </b-row>
            <b-row class="mb-2 align-items-center">
              <b-col cols="5">Snapshot and Upload</b-col>
              <b-col cols="7">
                <div class="d-flex flex-wrap">
                  <b-form-checkbox v-for="ch in channelOptions" :key="'snap-'+ch.id" v-model="linkageForm.snapshot_upload" :value="ch.id" class="me-2" @input="chageCustomProfile">
                    <label class="ms-1">{{ ch.name }}</label>
                  </b-form-checkbox>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <div class="text-end mt-3">
          <b-button variant="primary" @click="saveLinkage" @input="chageCustomProfile">Close</b-button>
        </div>
      </div>
    </b-modal>

    <confirmation
      v-if="modalConfirm"
      :modal.sync="modalConfirm"
      message="Yakin ingin menyimpan pengaturan ADAS?"
      @confirmed="afterConfirm"
      centered
    />

    <b-modal
      v-model="modalUnsavedConfirm"
      class="mc-modal"
      title="Konfirmasi"
      centered
      hide-footer
    >
      <p>Perubahan belum disimpan. Apakah Anda ingin menyimpan perubahan?</p>
      <div class="text-end">
        <b-button variant="outline-secondary" @click="closeModalWithoutSaving" class="me-3">
          Tutup tanpa menyimpan
        </b-button>
        <b-button variant="primary" :disabled="!this.adasInitialValue" @click="saveAndCloseModal">
          Simpan
        </b-button>
      </div>
    </b-modal>
  </div>
</template>
